import Axios from "axios";
export default {
  name: "ToolOSS",
  data: function data() {
    return {
      // 工具1: 通过密文得到sys的密码明文
      loading_pswd: false,
      pswd: '',
      pswText: '',
      pswCode: '',
      // 工具2: 通过密文得到原授权ID
      loading_id: false,
      authorizationID: '',
      authorizationIDText: '',
      authorizationIDCode: ''
    };
  },
  methods: {
    findSn: function findSn() {
      var _this = this;
      this.pswText = '';
      this.loading_pswd = true;
      Axios.get("/pmv5/service/system/get-os-pswd/?ciphertext=".concat(this.pswd)).then(function (resp) {
        var data = resp.data;
        _this.pswCode = data.code;
        if (_this.pswCode === 0) {
          _this.pswText = data.text;
        }
      }).finally(function () {
        _this.loading_pswd = false;
      }).catch(function () {});
    },
    findIDSn: function findIDSn() {
      var _this2 = this;
      this.loading_id = true;
      this.authorizationIDText = '';
      Axios.get("/pmv5/service/system/get-active-id/?ciphertext=".concat(this.authorizationID)).then(function (resp) {
        var data = resp.data;
        _this2.authorizationIDCode = data.code;
        if (_this2.authorizationIDCode === 0) {
          _this2.authorizationIDText = data.text;
        }
      }).finally(function () {
        _this2.loading_id = false;
      }).catch(function () {});
    }
  }
};